import { useState } from 'react';
import useSlingApi from '@sdk/api/useSlingApi';
import type { DocumentData } from '@sdk/users/types/DocumentData';

export const useDocumentPreview = (document: DocumentData) => {
  const [isOpen, setIsOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string>('');
  const api = useSlingApi();

  const preparePreview = async () => {
    const { data: blob } = await api.users.getDocument(document);
    setPreviewUrl(URL.createObjectURL(blob));
  };

  return {
    isOpen,
    setIsOpen,
    previewUrl,
    preparePreview,
  };
};
